export enum TEMPLATES {
  PROGRESS = 'progressionBar',
  GUIDE_TV = 'guideTv',
  UNDERSCORE = 'underscore',
  IMAGES = 'images'
}

export const DEFAULT_TEMPLATE = TEMPLATES.GUIDE_TV;
